import currency from "currency.js";
import { commonConstants, creditCardConstants } from "../_redux/_constants";
import { validCreditCard } from "./support.services";

const formatCardExpiryDate = (cardExpDate) => {
  if (!cardExpDate) {
    return "";
  }

  let month;
  let year;

  if (cardExpDate.length === 6) {
    year = cardExpDate.slice(2, 4);
    month = cardExpDate.slice(4, 6);
    return `${month}/${year}`;
  }

  if (cardExpDate.length === 4) {
    year = cardExpDate.slice(0, 2);
    month = cardExpDate.slice(2);
    return `${month}/${year}`;
  }

  return "";
};

const formatNumberWithCurrency = (number, currencySymbol) => {
  const num = parseFloat(number);
  if (isNaN(num)) return `${currencySymbol} 0`;

  const formattedNumber = currency(Math.abs(num), {
    symbol: `${currencySymbol} `,
    separator: ",",
    precision: 2,
    formatWithSymbol: true,
  }).format();
  return num < 0
    ? `${currencySymbol} -${formattedNumber.slice(currencySymbol.length + 1)}`
    : formattedNumber;
};

const creditCardStatusColorManage = (cardStatus) => {
  switch (cardStatus) {
    case creditCardConstants.CARD_STATUS_CACT:
      return { name: "Active", className: "df-green-linked-btn" };
    case creditCardConstants.CARD_STATUS_VALID_CARD:
      return { name: "Active", className: "df-green-linked-btn" };
    case creditCardConstants.CARD_STATUS_IACT:
      return { name: "Inactive", className: "df-red-linked-btn" };
    case creditCardConstants.CARD_STATUS_CAPC:
      return { name: "Card Upgraded", className: "df-primary-linked-btn" };
    case creditCardConstants.CARD_STATUS_CDEA:
      return { name: "Deactivated", className: "df-warning-linked-btn" };
    case creditCardConstants.CARD_STATUS_CARP:
      return { name: "Card Replaced", className: "df-primary-linked-btn" };
    case creditCardConstants.CARD_STATUS_CATB:
      return { name: "Temporarily Blocked", className: "df-red-linked-btn" };
    case creditCardConstants.CARD_STATUS_CAPB:
      return { name: "Permanently Blocked", className: "df-red-linked-btn" };
    case creditCardConstants.CARD_STATUS_CAEX:
      return { name: "Expired", className: "df-red-linked-btn" };
    default:
      return { name: "Unknown", className: "df-primary-linked-btn" };
  }
};

const getRecentTransactions = (transactionList = [], limit = 5) => {
  if (!Array.isArray(transactionList)) return [];
  return transactionList.slice(0, limit);
};

const creditCardNumberFormatter = (cardNumber) => {
  if (cardNumber != "") {
    if (
      cardNumber.length <= creditCardConstants.CREDIT_CARD_LENGTH_WITH_SPACES
    ) {
      let card = cardNumber
        .replace(/\D/g, "")
        .replace(/(.{4})/g, "$1 ")
        .trim();
      if (card) {
        return card;
      } else {
        return "";
      }
    } else {
      return cardNumber.substring(
        0,
        creditCardConstants.CREDIT_CARD_LENGTH_WITH_SPACES,
      );
    }
  } else {
    return "";
  }
};

const creditCardNumberRestorer = (cardNumber) => {
  if (cardNumber != "") {
    return cardNumber
      .replace(/\s+/g, "")
      .substring(0, creditCardConstants.CREDIT_CARD_LENGTH_WITHOUT_SPACES);
  } else {
    return "";
  }
};

const creditCardRegex =
  /^(?:4\d{12}(?:\d{3})?(?:\d{3})?|5[1-5]\d{14}|2(?:2[2-9][1-9]|2[3-9]\d{2}|[3-6]\d{3}|7[01]\d{2}|720\d)\d{12}|3[47]\d{13}|6(?:011|5\d{2}|4[4-9]\d)\d{12})$/;
const validateCreditCardNumber = (number, t) => {
  // this is the not show any error message when there is a letter typed instead of a number
  //assuming the input field is restricting the input of characters from frontend

  if (/^[a-zA-Z]$/.test(number)) {
    return false;
  }

  // const cleanedNumber = number.replace(/\s+/g, "");

  // if (!creditCardRegex.test(cleanedNumber)) {
  //   return t
  //     ? t("Please enter a valid card number")
  //     : "Please enter a valid card number";
  // }

  // if (!isValidCreditCard(cleanedNumber)) {
  //   return t
  //     ? t("Please enter a valid card number")
  //     : "Please enter a valid card number";
  // }

  return null;
};

const formatDebitCardInput = (input, t) => {
  const cleaned = input.replace(/\D/g, "");
  const formatted = creditCardNumberFormatter(cleaned);
  const isValid = validCreditCard(cleaned);

  const error =
    cleaned && !isValid ? t("Please enter a valid card number") : "";

  return {
    cleaned,
    formatted,
    error,
  };
};

// Validates credit card numbers using the Luhn algorithm

function isValidCreditCard(number) {
  if (number === null || number === "") return false;
  const digits = number.replace(/\D/g, "");
  let sum = 0;
  let shouldDouble = false;

  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = parseInt(digits[i], 10);
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
}

export {
  formatCardExpiryDate,
  creditCardStatusColorManage,
  formatNumberWithCurrency,
  getRecentTransactions,
  creditCardNumberFormatter,
  creditCardNumberRestorer,
  validateCreditCardNumber,
  formatDebitCardInput,
  isValidCreditCard,
};
